if (!customElements.get("product-grid-section")) {
    class ProductGridSection extends HTMLElement {
        constructor() {
            super();
            this.initProductCount();
            this.initSwatchEvent();
            this.moreButton();
        }

        moreButton() {
            const productGridSectionButton = this.querySelectorAll('.k-custom__more_button');
            productGridSectionButton.forEach((button) => {
                button.addEventListener('click', () => {
                    const target = button.previousElementSibling;

                    // 检查 target 是否存在且是否具有 .more-button-target 类
                    if (target && target.classList.contains('more-button-target')) {
                        // 只改变 .more-button-target 的直接子元素
                        Array.from(target.children).forEach((child) => {
                            child.style.display = '';
                        });
                        button.style.display = 'none';
                    }
                });
            });
        }

        initProductCount() {
            const productList = this.querySelector('.product-grid-section-container__list_wrapper');
            const productCount = parseInt(this.getAttribute('data-product-count-pc'), 10);
            const productCountMobile = parseInt(this.getAttribute('data-product-count-mb'), 10);
            const moreButton = this.querySelector('.k-custom__more_button');

            // 初始化matchMedia
            const mediaQuery = window.matchMedia('(max-width: 1000px)');

            const updateProductDisplay = (count) => {
                // 获取所有 .item 元素
                const items = productList.querySelectorAll('.item');

                // 移除所有元素的 display 属性
                items.forEach(item => item.style.removeProperty('display'));

                // 判断数量并更新 display 属性
                items.forEach((item, index) => {
                    if (index >= count) {
                        item.style.display = 'none';
                    }
                });
            };

            // 检查按钮的可见性
            const isButtonVisible = moreButton && moreButton.offsetParent !== null;

            // 初始调用，根据当前屏幕宽度设置显示数量
            if (isButtonVisible) {
                if (mediaQuery.matches) {
                    updateProductDisplay(productCountMobile);
                } else {
                    updateProductDisplay(productCount);
                }
            }

            // 监听屏幕宽度变化，自动更新显示数量
            mediaQuery.addEventListener('change', (e) => {
                // 在监听变化时再次检查按钮的可见性
                const buttonVisibleOnChange = moreButton && moreButton.offsetParent !== null;

                if (buttonVisibleOnChange) {
                    console.log('mediaQuery changed:', e.matches);
                    if (e.matches) {
                        updateProductDisplay(productCountMobile);
                    } else {
                        updateProductDisplay(productCount);
                    }
                }
            });
        }

        initSwatchEvent() {
            this.addEventListener('mouseenter', (event) => {
                const target = event.target;
                if (target.matches('.swatch__list_js > span')) {
                    const nowid = target.getAttribute('data-vid');
                    console.log('nowid:', nowid);

                    const comproitem = target.closest('.comproitem');
                    if (comproitem) {
                        const combieInput = comproitem.querySelector('.js_sticky_combie');
                        if (combieInput) {
                            combieInput.value = nowid;
                        }
                    }
                }
            }, true); // 使用捕获阶段监听
        }
    }

    customElements.define("product-grid-section", ProductGridSection);
}
